import { createMuiTheme } from "@material-ui/core/styles";

// Create a theme instance.
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2A89F6"
    },
    secondary: {
      main: "#19857b"
    },
    error: {
      main: "#ED3E3E"
    },
    background: {
      default: "#fff"
    },
    colors: {
      error: "#c41f1f",
      azureWhite: "#E2E5EF",
      pDark: "#191B1F",
      secondary: "#FF7765"
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: ["Source Sans Pro", "sans-serif"],
    color: "#2E2E36",
    defaultFont: {
      fontFamily: ["Source Sans Pro", "sans-serif"],
      color: "#2E2E36",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "18px",
      textAlign: "left",
      textTransform: "none"
    },
    secondaryFont: {
      fontFamily: ["Source Sans Pro", "sans-serif"],
      color: "#263838",
      fontSize: 16,
      fontWeight: 700,
      lineHeight: "24px",
      textAlign: "left",
      textTransform: "none"
    },
    tertiaryFont: {
      fontFamily: ["Source Sans Pro", "sans-serif"],
      color: "#54747A",
      fontSize: 12,
      fontWeight: 500,
      lineHeight: "16px",
      textAlign: "left",
      textTransform: "none"
    },
    semiRegular: {
      fontFamily: ["Source Sans Pro", "sans-serif"],
      color: "#263838",
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "20px",
      textAlign: "left",
      textTransform: "none"
    },
    semiBoldFont: {
      fontFamily: ["Source Sans Pro", "sans-serif"],
      color: "#263838",
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "20px",
      textAlign: "left",
      textTransform: "none"
    },
    boldFont: {
      fontFamily: ["Source Sans Pro", "sans-serif"],
      color: "#263838",
      fontSize: 14,
      fontWeight: 700,
      lineHeight: "20px",
      textAlign: "left",
      textTransform: "none"
    },
    faqFont: {
      color: "#41485A",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "17px",
      textAlign: "left",
      textTransform: "none"
    },
    font1: {
      fontSize: "21px",
      lineHeight: "26px",
      [`@media (min-width:${`576`}px)`]: {
        fontSize: "23px",
        lineHeight: "28px"
      }
    },
    font2: {
      fontSize: "17px",
      lineHeight: "20px",
      [`@media (min-width:${`576`}px)`]: {
        fontSize: "19px",
        lineHeight: "22px"
      }
    },
    label: {
      fontSize: "13px",
      lineHeight: "14px"
    }
  },
  flexClass: {
    display: "flex",
    alignItems: "center"
  },
  customScroll: {
    "&::-webkit-scrollbar": { width: "3.5px" },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "1px",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.2)"
    }
  },
  customTextfield: {
    border: "1px solid #E2E5EF",
    borderRadius: "6px",
    width: "320px",
    height: "40px",
    padding: "0"
  },
  customFieldPadding: {
    padding: "11.5px 14px",
    fontWeight: 600,
    color: "#2E2E36",
    fontSize: "15px",
    lineHeight: "20px",
    "&::-webkit-input-placeholder": {
      // color: "#8D9DC1",
      fontWeight: 400
    }
  },
  breaks: {
    web: 576
  },
  customOutline: {
    border: "none",
    boxShadow: "none",
    borderColor: "#ffffff !important"
  },
  defaultButton: {
    border: "none",
    userSelect: "none",
    textAlign: "initial",
    fontSize: "inherit",
    padding: "0",
    margin: "0",
    cursor: "pointer"
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": { borderWidth: 0 },
        // "&:hover $notchedOutline": { borderColor: "#2E2E36" },
        "&$focused $notchedOutline": { borderColor: "#2A89F6" }
      }
    }
  }
});

export default theme;
